export const SET_LOADING_MESSAGE = 'SET_LOADING_MESSAGE';
export const RESET_LOADING_MESSAGE = 'RESET_LOADING_MESSAGE';
export const ADD_TO_LOGGING = 'ADD_TO_LOGGING';
export const RESET_LOGGING_LIST = 'RESET_LOGGING_LIST';